export const links = {
  root: '/HousingStock',
  rootWithCompany: '/HousingStock/company',
  houses: 'houses',
  changing: 'changing/:id',
  changingAll: 'changingAll',
  changingAllTwo: 'changingAllTwo',
  reportRSO: 'reportRSO',
  house: {
    main: ':pageId/:pageTab?/:pageTabId?',
    pages: {
      flats: 'flats',
      flat: ':pageTabId',
      tenants: 'tenants',
      info: 'info',
      meters: 'meters',
      personalAccounts: 'personal-accounts',
    },
  },
  tenants: 'tenants',
  personalAccounts: 'personal-accounts',
  exports: 'exports',
  imports: 'imports',
};
